export default __webpack_public_path__ + "static/media/Agreement.5ed9b896.png";